export const followUpTasks = {
  title: 'My Tasks: Follow-up',
  allOption: 'All',
  assignedToLabel: 'Assigned To',
  taskTypeLabel: 'Task Type',
  taskCategoryLabel: 'Task Category',
  dueDateLabel: 'Due Date',
  dueDateRangeLabel: 'Due Date Range',
  dueDateOptions: {
    all: 'All',
    thisMonth: 'This Month',
    next30Days: 'Next 30 Days',
    last30Days: 'Last 30 Days',
    customRange: 'Custom Range'
  },
  selectOptionPlaceholder: 'Select an option...',
  grid: {
    patientName: 'Patient Name',
    taskType: 'Task Type',
    category: 'Category',
    alertType: 'Alert Type',
    taskDueAt: 'Task Due at',
    assignedTo: 'Assigned To',
    followUpTaskNote: 'Follow-up Task Note',
    actions: 'Actions'
  },
  tooltips: {
    editFollowUp: 'Edit Follow-up',
    completeFollowUp: 'Complete Follow-up',
    cannotCompleteOtherAssignee: 'You cannot mark this follow-up as completed, because it is assigned to another assignee',
    alreadyAssignedToYou: 'This task is already assigned to you',
    assignToYourself: 'Assign to yourself'
  },
  dialogs: {
    taskInfoTitle: 'Follow-up Task Information',
    confirmReassignmentTitle: 'Confirm Task Reassignment',
    confirmReassignmentMessage: (assigneeName: string) =>
      `This task is currently assigned to <b>${assigneeName}</b>. Would you like to reassign it to yourself?`
  },
  snackbars: {
    unexpectedUpdateError: 'Unexpected error occurred while updating a follow-up task',
    encounterOrPatientIdNotFound: 'Encounter ID or Patient ID not found for follow-up'
  },
  addEditForm: {
    dueDateLabel: 'Follow-up Due Date',
    typeLabel: 'Follow-up Type',
    assigneeLabel: 'Follow-up Assignee',
    assigneePlaceholder: 'select an option',
    recommendationActionsTitle: 'Recommendation Actions',
    notePlaceholder: 'Type your note here',
    noteLabel: 'Notes'
  }
} as const;
